module.exports = __webpack_public_path__ + "img/tpc-3.00ba0d86.webp";